import { render, staticRenderFns } from "./SurveyThanks.vue?vue&type=template&id=7d900029&"
import script from "./SurveyThanks.vue?vue&type=script&lang=js&"
export * from "./SurveyThanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports